export default "__VITE_ASSET__CHI9rewH__"